import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'hooks/apollo';
import { PROCESSING_REPORTS_VERIFICATION_MUTATION } from './mutations';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { reportsVerificationStore } from './ReportVerificationListBrowser';
import MemoryIcon from '@mui/icons-material/Memory';

const ReportVerificationActions = ({ dataIsProcessing, setDataIsProcessing }) => {
  const { t } = useTranslation();
  const { addActions } = useListBrowserUtils(reportsVerificationStore);

  const [startInterrogationsReportFlow] = useMutation(PROCESSING_REPORTS_VERIFICATION_MUTATION);

  const handleReportProcessing = useCallback(() => {
    setDataIsProcessing(true);
    startInterrogationsReportFlow({ variables: {} });
  }, [setDataIsProcessing, startInterrogationsReportFlow]);

  useEffect(() => {
    addActions([
      {
        name: 'ReportVerification',
        label: t('ReportsVerification.ReportProcessing'),
        icon: <MemoryIcon />,
        handler: handleReportProcessing,
        disabled: dataIsProcessing
      }
    ]);
  }, [addActions, dataIsProcessing, handleReportProcessing, t]);

  return <></>;
};
ReportVerificationActions.propTypes = {
  dataIsProcessing: PropTypes.bool.isRequired,
  setDataIsProcessing: PropTypes.func.isRequired
};

export default ReportVerificationActions;
